import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { AppRoutingBaseComponent } from "@app/shared/components/app-routing-base.component";
import { UiLibraryModule } from '@template-ui/template-ui.module';
import { RouterOutlet } from "@angular/router";
import { FooterComponent } from "@app/shared/components/footer/footer.component";
import { EzAppComponent } from "@template-ui/components/ez-app/ez-app.component";
import { MastheadComponent } from "@app/shared/components/masthead/masthead.component";
import { MatSidenavContainer, MatSidenavModule } from "@angular/material/sidenav";
import { SideNavComponent } from "@app/shared/components/navigation/side-nav/side-nav.component";
import { SideRailNavComponent } from "@app/shared/components/navigation/side-rail-nav/side-rail-nav.component";
import { TitleService } from "@app/shared/services/title.service";
import { CustomPrimeToastComponent } from "@app/shared/components/custom-prime-toast/custom-prime-toast.component";
import { CaseSummaryBarComponent } from "@app/shared/components/case-summary-bar/case-summary-bar.component";
import { trigger, state, style, transition, animate } from "@angular/animations";
import InsertTextButton from "@template-ui/ckEditor/plugins/InsertTextButton";
import { NavService } from "@app/core/services/nav.service";
import { AuthService } from '@app/core/services/auth.service';
import { PhmsDetailNavBarComponent } from "@app/phms/navigation/phms-detail-nav-bar.component";
import { ApplicationBannerHostComponent } from "@app/shared/components/application-banner-host/application-banner-host.component";
import { WorkflowContextBarHostComponent } from "@app/shared/components/workflow-context-bar-host/workflow-context-bar-host.component";
import { TerminologyContextMenuComponent } from '@app/shared/terminology/terminology-context-menu.component';

/**
 * Copied from the original app.component but left that one deprecated for reference.
 * TODO: Utilize the EZ-App so this has less stuff. It should be easy to create an app component
 * based off EZ-App
 */
@Component({
    selector: 'app-root',
    templateUrl: './riley-app.component.html',
    styleUrl: './riley-app.component.scss',
    imports: [
        CommonModule,
        UiLibraryModule,
        RouterOutlet,
        EzAppComponent,
        MatSidenavContainer,
        MatSidenavModule,
        SideNavComponent,
        SideRailNavComponent,
        MastheadComponent,
        FooterComponent,
        CustomPrimeToastComponent,
        CaseSummaryBarComponent,
        PhmsDetailNavBarComponent,
        ApplicationBannerHostComponent,
        WorkflowContextBarHostComponent,
        TerminologyContextMenuComponent,
    ],
    animations: [
        trigger("fadeInOut", [
            state("void", style({
                opacity: 0,
                transform: "translateY(-20px)"
            })),
            transition("void <=> *", [animate("500ms ease-in-out")])
        ]),
        trigger("slideInOut", [
            state("collapsed", style({ height: 0, opacity: 0, zIndex: 0 })),
            state("expanded", style({ height: "*", opacity: 1 })),
            transition("collapsed <=> expanded", [
                animate("700ms ease")
            ])
        ]),
        trigger("summaryShowHde", [
            state("collapsed", style({ height: "0px", opacity: 0, padding: 0 })),
            state("expanded", style({
                height: "*",
                opacity: 1,
                padding: "16px",
                paddingTop: 0
            })),
            transition("collapsed <=> expanded", [
                animate("300ms ease")
            ])
        ])
    ]
})
export class RileyAppComponent extends AppRoutingBaseComponent {
  // footerCmp = FooterComponent;
  // headerComponent = MastheadComponent;

  title = 'Riley JMS';

  titleService = inject(TitleService);
  navService = inject(NavService);
  authService = inject(AuthService);
  sideNavOffset = 50;  // TODO: This is the masthead height, get from a variable?
  readonly showShell = signal(true);

  railNavItems = computed(() => {
    return this.navService.sideNavMenuItems();
  });

  // Classes based on signals
  appClasses = computed(() => ({
    'ez-dev-mode': this.bitsStateService.devModeSignal(),
    'isBusy': this.bitsStateService.isBusySignal(),
    'isDev': this.roles.isDeveloper()
  }));

  constructor() {
    super();

    // Setup an injector for the InsertTextButton ckEditor plugin
    InsertTextButton.setDefaultInjector(this.injector);

    this.showShell.set(!this.authService.isPublicRoute(this.router.url));

    effect(() => {
      const navigationEnd = this.navigationEndSignal();
      if (!navigationEnd) {
        return;
      }

      this.showShell.set(!this.authService.isPublicRoute(navigationEnd.urlAfterRedirects));
    }, { allowSignalWrites: true });
  }

  onRailModeChanged(mode: 'rail' | 'expanded'): void {
    this.bitsStateService.navMode.set(mode);
  }

  // Called once after the first @Input() values are set
  // Use this for initialization logic (fetch data, set defaults)
  ngOnInit() {
    this.titleService.init(); //TODO: this should be in our providers array
  }

  // Called once after the component’s view (and child views) are initialized
  // Use this for DOM-dependent logic. i.e. a component exists inside an an *ngIf.
  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

}
